
import React from "react";
import { MessageSquareX } from "lucide-react";

interface DeletedChatIndicatorProps {
  partnerName: string;
  deletedByCurrentUser?: boolean;
  deletedByPartner?: boolean;
}

export const DeletedChatIndicator: React.FC<DeletedChatIndicatorProps> = ({ 
  partnerName, 
  deletedByCurrentUser, 
  deletedByPartner 
}) => {
  const getMessage = () => {
    if (deletedByCurrentUser) {
      return "Você finalizou esta conversa";
    } else if (deletedByPartner) {
      return "Esta conversa foi finalizada pelo outro usuário";
    } else {
      // Fallback para conversas antigas sem deleted_by
      return "Esta conversa foi finalizada";
    }
  };

  return (
    <div className="flex items-center space-x-2 text-white/50">
      <MessageSquareX className="h-4 w-4 text-luxury-red/60" />
      <span className="text-sm italic">
        {getMessage()}
      </span>
    </div>
  );
};
